const PageLogsTracking = () => import('./PageLogsTracking');
const PageLogsTrackingDetail = () => import('./pages/logs-tracking-detail/PageLogsTrackingDetail');
const PageLogsTrackingLoteDetail = () => import('./pages/logs-tracking-lote-detail/PageLogsTrackingLoteDetail');

export default {
  path: 'tracking',
  children: [
    {
      name: 'logs-tracking',
      path: '',
      meta: {
        title: 'Logs de Rastreamento - Eventos',
      },
      component: PageLogsTracking,
    },
    {
      name: 'logs-tracking-lote',
      path: 'lote/:id',
      meta: {
        title: 'Lote {{ id }} - Logs de Rastreamento',
      },
      component: PageLogsTrackingLoteDetail,
    },
    {
      name: 'logs-tracking-detail',
      path: ':hash/:original_code?',
      params: {
        hash: null,
        original_code: null,
      },
      meta: {
        title: 'Evento {{ hash }} - {{ original_code }} - Logs de Rastreamento',
      },
      component: PageLogsTrackingDetail,
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/routes.js